module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/account-img-90b401961acf3202f3b328110d3eab22.png";